module.exports = __webpack_public_path__ + "img/food-stand.799c1335.png";